import React from 'react';
import { Upload, Button, Typography, Form } from 'antd';
import { CloudUpload, DocumentBlank, Close } from '@carbon/icons-react';
import {
  checkIfFileTypeIsSupported,
  checkIfFileSizeIsSupported,
  handleUnsupportedFileType,
  handleUnsupportedFileSize,
} from 'components/UploadFile/UploadFile';

const { Text } = Typography;

function UploadFileField({ value = [], onChange, multiple = true, className }) {
  const handleFileChange = ({ fileList }) => {
    onChange?.(fileList);
  };

  const handleRemoveFile = (file) => {
    const updatedList = value.filter((f) => f.uid !== file.uid);
    onChange?.(updatedList);
  };

  const beforeUpload = async (file) => {
    if ((await checkIfFileTypeIsSupported(file)) === false) {
      handleUnsupportedFileType(file);
      return false || Upload.LIST_IGNORE;
    }

    if (checkIfFileSizeIsSupported(file) === false) {
      handleUnsupportedFileSize(file);
      return false || Upload.LIST_IGNORE;
    }

    return false; // Prevent auto-upload
  };

  return (
    <>
      {/* Selected files list */}
      {value.length > 0 && (
        <div className="mb-4">
          <Text className="text-sm font-medium block mb-2">Selected Files ({value.length}):</Text>
          <div className="space-y-2">
            {value.map((file) => (
              <div
                key={file.uid}
                className="flex items-center justify-between px-4 py-2 bg-[#f9fafb] rounded-xl border-solid border border-[#e9e9e9]"
              >
                <div className="flex items-center gap-3 flex-1">
                  <DocumentBlank size={24} className="text-gray-600 flex-shrink-0" />
                  <div className="flex items-center gap-2 flex-1">
                    <Text className="font-normal text-base">{file.name}</Text>
                    <Text className="text-sm text-gray-500">({(file.size / 1024 / 1024).toFixed(2)} MB)</Text>
                  </div>
                </div>
                <Button
                  type="text"
                  icon={<Close size={20} />}
                  onClick={() => handleRemoveFile(file)}
                  className="hover:!bg-gray-200 flex-shrink-0"
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Upload button */}
      <Upload
        multiple={multiple}
        fileList={value}
        onChange={handleFileChange}
        beforeUpload={beforeUpload}
        showUploadList={false}
        accept=".pdf, .jpg, .jpeg, .png, .heic"
        className={className}
      >
        <div className="flex items-center flex-wrap">
          <Button type="default" size="large" icon={<CloudUpload size={20} />} className="!h-12">
            Upload files
          </Button>

          <Text className="ml-4 text-gray-600">PDF, JPEG, PNG · Max 10MB</Text>
        </div>
      </Upload>
    </>
  );
}

export default function ChecklistUploadFile({ name = 'files', required = true, multiple = true, className }) {
  return (
    <Form.Item name={name} rules={[{ required, message: 'Please select at least one file to upload' }]}>
      <UploadFileField multiple={multiple} className={className} />
    </Form.Item>
  );
}
